const ABOUT_US_CONSTANTS = {
  BANNER: {
    IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/about-us-banner.webp`,
    ALT: "Sisir Radar - About us",
    HEADER: [
      "Revolutionising Earth Observation",
      "with Unmatched Radar Imaging",
    ],
  },
  WHO_WE_ARE:
    "Sisir Radar is an Indian spacetech company specialising in building high resolution SAR satellites with extremely high imaging coverage.",
  WHAT_WE_DO:
    "We design and develop world-class Synthetic Aperture Radar (SAR) payloads, Ground Penetrating Radar (GPR), Drone-borne Hyperspectral Imaging systems as well as conventional Radars. These technologies are designed to serve diverse industries, including defence, agriculture, mining, urban planning and environmental monitoring, by providing timely actionable insights to users.",
  WINS: "With the world’s highest resolution L band SAR, we have won 2 IDEX challenges from the Indian Ministry of Defence and have partnered with multiple organisations to address critical challenges.",
  MISSION: {
    IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/mission-image.webp`,
    ALT: "Sisir Radar Team Mission",
    HEADER: "MISSION",
    BODY: [
      "Our mission is to revolutionise earth observation with advanced imaging radars, delivering high resolution imaging and analytics for defence, security and environmental solutions.",
    ],
  },
  VISION: {
    IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/vision.webp`,
    ALT: "Sisir Radar Team Vision",
    HEADER: "VISION",
    BODY: [
      "Our vision is to become a global leader in SAR technology and one of the world's top providers of high-quality SAR data, driving innovation and advancing the boundaries of radar imaging.",
    ],
  },
  MID_SECTION_BG_IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/about-mission-vission-bg.webp`,
  MID_SECTION_BG_IMG_ALT: "Sisir Radar Team Mission and Vision",
  FOUNDERS: {
    HEADER: "FOUNDERS",
    PEOPLE: [
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/tm.webp`,
        ALT: "Tapan Misra - Sisir Radar Team Founder and Chairman",
        NAME: "DR TAPAN MISRA",
        DESIGNATION: "Founder and Chairman",
        DESCRIPTION: [
          "Guiding the development of cutting-edge SAR systems and algorithms innovation for terrestrial, aerial and spaceborne platforms.",
          "Dr Tapan Misra, a globally renowned expert in Synthetic Aperture Radar (SAR) technology, has over 40 years of experience in space technology and radar systems. As the former Director of ISRO’s Space Applications Centre and Physical Research Laboratory, he led projects such as RISAT (India’s first SAR-based reconnaissance satellite), Chandrayaan-2’s dual-frequency SAR and NISAR. He has developed SAR payloads across L, S, C and X bands for both airborne and spaceborne platforms. He holds 8 patents, 5 copyrights and has authored over 50 papers. He is a Fellow of FNAE, IAA, IETE, ISRS and an Adjunct Professor at IIT Jodhpur.",
        ],
        SOCIALS: {
          LINKEDIN: "https://in.linkedin.com/in/tapan-misra-2a6ba85",
          WIKIPEDIA: "https://en.wikipedia.org/wiki/Tapan_Misra",
        },
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/sm.webp`,
        ALT: "Soumya Misra - Sisir Radar Team Co-founder and CEO",
        NAME: "SOUMYA MISRA",
        DESIGNATION: "Co-founder and CEO",
        DESCRIPTION: [
          "Driving strategy, operations, product development and market expansion to drive growth and innovation.",
          "Soumya Misra has a rich background in hardware design, miniaturisation and image processing. He has designed GPUs at Intel and led smartphone design at Creo (a Sequoia-funded startup, later acquired by Hike). He was selected as one of India’s Top 50 mobile designers by the Government of India, he has also published multiple research papers in nanoelectronics.",
        ],
        SOCIALS: {
          LINKEDIN: "https://in.linkedin.com/in/soumya-tapan-misra",
        },
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/ub.webp`,
        ALT: "Urmi Bhambhani - Sisir Radar Team Co-founder and CTO",
        NAME: "URMI BHAMBHANI",
        DESIGNATION: "Co-founder and CTO",
        DESCRIPTION: [
          "Leading innovation across hardware, software and AI to advance cutting-edge radar systems.",
          "Urmi Bhambhani brings deep expertise in AI, machine learning and distributed systems. She previously built complex, large-scale distributed operating systems at NetApp and led the development of NLP-based AI products at Educational Initiatives. She is a Technical Review Committee Member at the Grace Hopper Celebration India.",
        ],
        SOCIALS: {
          LINKEDIN: "https://in.linkedin.com/in/urmi-bhambhani-misra?trk=people-guest_people_search-card",
        },
      },
    ],
  },
  HONORARY_ADVISORS: {
    HEADER: "HONORARY ADVISORS",
    PEOPLE: [
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/rkr.webp`,
        ALT: "Dr Russell Keith Raney - Honorary Advisor",
        NAME: "DR. RUSSELL KEITH RANEY",
        DESIGNATION: "Father of Modern SAR",
        DESCRIPTION: [
          "Dr Russell Keith Raney, a SAR technology pioneer, is known for innovations like Digital SAR processing, the Chirp Scaling algorithm and the Hybrid Polarimetry method, which revolutionised radar imaging. As the architect of Radarsat, he spearheaded the advent of digital SAR processing thereby ushering in the commercial viability of SAR in the 1990s.",
        ],
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/gmn.webp`,
        ALT: "Dr. G. Madhavan Nair - Honorary Advisor",
        NAME: "DR. G. MADHAVAN NAIR",
        DESIGNATION: "Former ISRO Chairman, Padma Vibhushan",
        DESCRIPTION: [
          "A visionary leader, Dr. G. Madhavan Nair spearheaded India’s first lunar mission, Chandrayaan-1 and oversaw the development of the GSLV as Director of ISRO’s Vikram Sarabhai Space Centre. A champion of self-reliance in high technology and leveraging space for societal development, he has been honoured with the Padma Bhushan (1998) and Padma Vibhushan (2009).",
        ],
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/am.webp`,
        ALT: "Prof. Dr.-Ing. Alberto Moreira - Honorary Advisor",
        NAME: "PROF. DR.-ING.ALBERTO MOREIRA",
        DESIGNATION:
          "Director of the Microwaves and Radar Institute, German aerospace center (DLR)",
        DESCRIPTION: [
          "Dr. Alberto Moreira, Director at DLR, is a radar technology pioneer known for innovations like polarimetric SAR interferometry and SAR tomography. He led the TanDEM-X mission, creating a high resolution global digital elevation model and served as President of IEEE GRSS in 2010. Dr. Moreira has co-authored multiple papers and patents on SAR with Dr. Tapan Misra.",
        ],
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/nsp.webp`,
        ALT: "N. S. Pillai - Honorary Advisor",
        NAME: "NEELAKANTAN SIVATHANU PILLAI",
        DESIGNATION: "Retired senior ISRO scientist",
        DESCRIPTION: [
          "N. S. Pillai, an expert in Microwave and Communication Engineering, played a key role in developing ISRO’s Cassegrain Antenna and Synthetic Aperture Radar systems. He led the development of India’s first C band airborne SAR and Scatterometer systems, advancing the indigenous development of spaceborne radar technology in India.",
        ],
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/sSomanath.webp`,
        ALT: "Dr. S. Somanath",
        NAME: "DR. S. SOMANATH",
        DESIGNATION: "Former ISRO Chairman",
        DESCRIPTION: [
          "Dr. S. Somanath is an aerospace engineer and former ISRO Chairman, celebrated for leading Chandrayaan‑3’s historic lunar south pole landing. Educated at TKM, IISc, and IIT Madras, he has directed major missions including GSLV Mk‑III, Aditya‑L1, Gaganyaan, and SSLV, shaping India’s Space Vision‑2047.",
        ],
      },
      {
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/sReddy.webp`,
        ALT: "Dr. G. Satheesh Reddy",
        NAME: "DR. G. SATHEESH REDDY",
        DESIGNATION: "Special Advisor to Defence Minister, Former DRDO Chairman",
        DESCRIPTION: [
          "Dr. G. Satheesh Reddy is a renowned Indian aerospace scientist and defence expert, currently serving as Advisor for Aerospace and Defence Manufacturing to the Andhra Pradesh government. As former DRDO Chairman, he spearheaded key missile programs and India’s first successful ASAT mission, Mission Shakti, earning widespread recognition for his contributions to the nation’s defence and aerospace capabilities.",
        ],
      },
    ],
  },
  OUR_JOURNEY: {
    HEADER: "OUR JOURNEY",
    CONTENT: [
      {
        HEADER: "2022",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/1.webp`,
        ALT: "Sisir Radar - Naming",
        TITLE: "Proud to Name Sisir Radar in Honour of Prof. Sisir K. Mitra",
        TEXTS: [
          "Professor Sisir K. Mitra conducted groundbreaking experiments in Kolkata, utilising RF signal reflections to measure atmospheric heights. His innovative methods, akin to modern bistatic radar systems, laid the foundation for radar technology. Sisir Radar proudly carries his legacy forward.",
        ],
      },
      {
        HEADER: "APR 2022",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/2.webp`,
        ALT: "Sisir Radar - Foundation",
        TITLE: "Foundation of Sisir Radar",
        TEXTS: [
          "Sisir Radar was founded by visionary leaders, including Dr Tapan Misra, Soumya Misra and Urmi Bhambhani, combining expertise in radar, hardware, AI and innovation to revolutionise radar technology.",
        ],
      },
      {
        HEADER: "DEC 2022",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/3.webp`,
        ALT: "Sisir Radar - Ground Penetrating Radar",
        TITLE: "Developed Ground Penetrating Radar",
        TEXTS: [
          "Sisir Radar tested a concept model of its GPR, achieving penetration up to 20m in moist Kolkata soil, showcasing innovative radar capabilities for ground exploration.",
        ],
      },
      {
        HEADER: "APR 2023",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/4.webp`,
        ALT: "Sisir Radar - Ultra High Bandwidth GPR",
        TITLE: "Developed Ultra High Bandwidth GPR",
        TEXTS: [
          "Upgraded GPR now offers better than 5 cm resolution, with real-time display capabilities, delivering exceptional radar performance. This was tested in the zinc mines of Vedanta.",
        ],
      },
      {
        HEADER: "JUN 2023",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/5.webp`,
        ALT: "Sisir Radar - L Band SAR",
        TITLE: "Successful Test of L band SAR",
        TEXTS: [
            "Sisir Radar successfully tested its drone-borne L Band SAR, in West Bengal, India. This SAR System utilises India’s first Software Defined Radar and offers a groundbreaking 1m resolution."
        ],
      },
      {
        HEADER: "OCT 2023",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/6.webp`,
        ALT: "Sisir Radar - IDEX Challenge",
        TITLE: "Wins PM's IDEX Challenge",
        TEXTS: [
            "Sisir Radar won 2 IDEX Challenges for developing L and P band SAR satellites with unfurlable antenna for the Indian Air Force, a testament to its innovative space technologies."
        ]
      },
      {
        HEADER: "APR 2024",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/7.webp`,
        ALT: "Sisir Radar - Cloud-Based SAR Processing",
        TITLE: "Cloud-Based SAR Processing",
        TEXTS: [
          "Sisir Radar achieved a 20x reduction in SAR data processing time by leveraging cloud technology for quasi-real-time data delivery."
        ]
      },
      {
        HEADER: "APR 2024",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/8.webp`,
        ALT: "Sisir Radar - Mosquito Larvae Detection",
        TITLE: "Mosquito Larvae Detection Breakthrough",
        TEXTS: [
            "Sisir Radar utilised hyperspectral imaging to detect mosquito larvae in water samples from 15m height, enabling precise vector targeting. This innovation minimises insecticide use, addressing mosquito-borne diseases effectively."
        ]
      },
      {
        HEADER: "JUL 2024",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/9.webp`,
        ALT: "Sisir Radar - Sub-Meter L Band GB SAR Imaging",
        TITLE: "Sub-Meter L Band GB SAR Imaging",
        TEXTS: [
          "Achieved sub-meter resolution in L band Ground-borne SAR for low-speed vehicles, overcoming motion challenges with advanced motion compensation algorithms."
        ]
      },
      {
        HEADER: "SEP 2024",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/10.webp`,
        ALT: "Sisir Radar - Top Defence Tech Recognition",
        TITLE: "Top Defence Tech Recognition",
        TEXTS: [
          `Sisir Radar was named a "Top 10 Most Recommended Defence Technology Provider – 2024" by CIO Insider India. CEO announced plans for a SAR satellite constellation launch, advancing India's defence and radar technology globally.`
        ]
      },
      {
        HEADER: "SEP 2024",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/11.webp`,
        ALT: "Sisir Radar - MoU for SAR Satellite Constellation",
        TITLE: "MoU for SAR Satellite Constellation",
        TEXTS: [
          "Sisir Radar signed an MoU with Nibe Space to supply SAR satellites for their private earth observation constellation that will deliver high resolution imagery, benefiting military and industrial sectors."
        ]
      },
      {
        HEADER: "OCT 2024",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/12.webp`,
        ALT: "Sisir Radar - India’s First X Band SAR",
        TITLE: "India’s First X Band SAR",
        TEXTS: [
            "Sisir Radar developed a 30 cm resolution X band SAR, applicable across drone, airborne and spaceborne platforms, redefining high resolution imaging in India."
        ]
      },
      {
        HEADER: "DEC 2024",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/13.webp`,
        ALT: "Sisir Radar - L Band Hybrid Polarimetric SAR",
        TITLE: "L Band Hybrid Polarimetric SAR",
        TEXTS: [
            "Showcased a 1.15km x 2.15km hybrid polarimetric SAR image with sub-metric resolution and automatic geo-tagging."
        ]
      },
      {
        HEADER: "Feb 2025",
        IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/About/14.webp`,
        ALT: "Sisir Radar - Highest Resolution P Band Polarimetric SAR",
        TITLE: "Highest Resolution P Band Polarimetric SAR",
        TEXTS: [
            "Showcased the highest resolution polarimetric image, revealing maturing Rabi crops and fish farming ponds, and highlighting the P-band’s superior foliage penetration, with minimal green signatures from crops and strong blue (ground/inclined surfaces) and red (tree trunks) reflections."
        ]
      }
    ],
  },
};

export default ABOUT_US_CONSTANTS;
